// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"651":"ce6400492158ac31","741":"f3dfc5290f53e07e"}[chunkId] + ".js";
};